import { render } from "./InitializationError.vue?vue&type=template&id=b2dd9586&scoped=true"
import script from "./InitializationError.vue?vue&type=script&lang=js"
export * from "./InitializationError.vue?vue&type=script&lang=js"

import "./InitializationError.vue?vue&type=style&index=0&id=b2dd9586&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2dd9586"]])

export default __exports__